<template>
  <footer class="wg-footer">
    <div class="wg-footer-inner">
      <div>
        <strong>WhatsApp GB</strong>
        <p>
          O whats-gb.app é apenas um site informativo. Não hospedamos APK, não somos oficiais,
          não somos afiliados à WhatsApp Inc. e não somos um site de afiliados.
        </p>
      </div>
      <nav class="wg-footer-legal" aria-label="Footer">
        <a href="/privacy-policy/">Política de Privacidade</a>
        <a href="/about-us/">Sobre nós</a>
        <a href="/disclaimer/">Aviso legal</a>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style lang="scss">
.wg-footer {
  background: #eef7f2;
  color: #405147;
  padding: 22px 0;
  border-top: 1px solid #d5eadf;
}

.wg-footer-inner {
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto;
  display: grid;
  gap: 10px;
  justify-items: center;
  text-align: center;
}

.wg-footer strong {
  color: #10251a;
  font-family: var(--wg-font-heading, 'Oswald', 'Arial Narrow', Arial, sans-serif);
  font-size: 18px;
  font-weight: 400;
}

.wg-footer p {
  max-width: 820px;
  margin: 6px 0 0;
  line-height: 1.5;
  font-size: 14px;
}

.wg-footer-legal {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  justify-content: center;
  font-size: 14px;
}

.wg-footer a {
  color: #145c39;
  font-family: var(--wg-font-heading, 'Oswald', 'Arial Narrow', Arial, sans-serif);
  text-decoration: none;
  font-weight: 400;
  letter-spacing: 0;
}

.wg-footer a:hover {
  color: #0d4f37;
  text-decoration: underline;
  text-underline-offset: 4px;
}

@media (max-width: 760px) {
  .wg-footer {
    padding: 20px 0;
  }

  .wg-footer-legal {
    gap: 10px 14px;
  }
}
</style>
